import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import api from "../services/ApiService";

const GenerateInvoiceButton = ({ saleId, type = "installation" }) => {
  const handleGenerateInvoice = async () => {
    let endpoint = "";
    let filename = "";

    if (type === "installation") {
      endpoint = `https://crm-backend.monit.tech/generate-installation-invoice/${saleId}/`;
      filename = `installation_invoice_${saleId}.pdf`;
    } else if (type === "removal") {
      endpoint = `https://crm-backend.monit.tech/generate-remove-transfer-invoice/${saleId}/`;
      filename = `remove_transfer_invoice_${saleId}.pdf`;
    } else if (type === "repair") {
      endpoint = `https://crm-backend.monit.tech/generate-repair-replacement-invoice/${saleId}/`;
      filename = `repair_replacement_invoice_${saleId}.pdf`;
    }

    try {
      const response = await api.get(endpoint.replace('https://crm-backend.monit.tech', ''), { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = fileURL;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error generating invoice:', error);
      alert('Failed to generate invoice');
    }
  };

  return (
    <Tooltip title="Generate Invoice">
      <IconButton onClick={handleGenerateInvoice} color="primary">
        <PictureAsPdfIcon />
      </IconButton>
    </Tooltip>
  );
};

export default GenerateInvoiceButton;
